const common = {
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  tip: 'Tip',
  warning: 'Warning',
  noData: 'No Data',
  deleteSuccess: 'Delete successfully',
  deleteFailed: 'Delete failed',
  operations: 'Operations',
  total: 'Total',
  previous: 'Previous',
  next: 'Next',
  search: 'Search',
  loading: 'Loading',
  unknown: 'Unknown',
  copyToClipboard: 'Click to copy',
  like: 'Like',
  dislike: 'Dislike',
  required: '{field} is required',
  reset: 'Reset',
  refresh: 'Refresh',
  min: 'Min',
  back: 'Back',
  max: 'Max',
  select: 'Select',
  selected: 'Selected',
  items: 'items',
  yes: 'Yes',
  no: 'No',
  unlimited: 'Unlimited',
  clear: 'Clear',
  expand: 'Expand',
  pin: 'Pin',
  unpin: 'Unpin',
  pinSuccess: 'Pin successfully',
  unpinSuccess: 'Unpin successfully',
  operationFailed: 'Operation failed',
  operationSuccess: 'Operation succeeded: {count}',
  batchAdd: 'Batch Add',
  batchTransfer: 'Move in Bulk',
  batchDelete: 'Batch Delete',
  batchActions: 'Batch Actions',
  filter: 'Filter',
  send: 'Send',
  sending: 'Sending...',
  more: 'More',
  justNow: 'Just now',
  hoursAgo: '{count}h ago',
  daysAgo: '{count}d ago',
  retry: 'Retry',
}

export default common
